import React, { useEffect, useState } from "react";
import settings from "../assets/img/HumQadamHome/settings.svg";
import about from "../assets/img/HumQadamHome/aboutus.svg";
import { useDispatch, useSelector } from "react-redux";
import { changeTab } from "../redux/TabSlice";
import { toast } from "react-toastify";
import { setBackFromSettings } from "../redux/PageSlice";
import ModalSettings from "./ModalSettings";

// SVG icon components for Contact and Feedback (filled)
const PhoneIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="#7F3354" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.27099 2.11999 4.18C2.09501 3.90347 2.12787 3.62476 2.2165 3.36162C2.30513 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00026 4.10999 2H7.10999C7.5953 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04207 3.23945 9.10999 3.72C9.23662 4.68007 9.47144 5.62273 9.80999 6.53C9.94454 6.88792 9.97366 7.27691 9.8939 7.65088C9.81415 8.02485 9.62886 8.36811 9.35999 8.64L8.08999 9.91C9.51355 12.4135 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" fill="#7F3354"/>
  </svg>
);

const FeedbackIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="#7F3354" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" fill="#7F3354"/>
  </svg>
);

function Options({ handleOpen, setShowData }) {
  const { district, selDistrictId } = useSelector((state) => state.district);
  const { province, selProvinceId } = useSelector((state) => state.province);
  const [openAbout, setOpenAbout] = useState(false);
  const { tab } = useSelector((state) => state.tab);
  const [pro, setPro] = useState();
  const [dis, setDis] = useState();
  const dispatch = useDispatch();

  const handleClose = () => {
    if (!selDistrictId) {
      toast.error("Select District");
      return;
    }
    setOpenAbout(false);
  };

  useEffect(() => {
    if (!district?.length) {
      setDis(null);
      return;
    }
    const match = district.find((d) => d._id === selDistrictId);
    setDis(match ?? null);
  }, [selDistrictId, district]);

  useEffect(() => {
    if (!province?.length) {
      setPro(null);
      return;
    }
    const match = province.find((p) => p._id === selProvinceId);
    setPro(match ?? null);
  }, [selProvinceId, province]);

  const handleClick = (tabS) => {
    if (!selDistrictId) {
      toast.error("Select District");
      return;
    }
    if (setShowData) setShowData([]);
    dispatch(setBackFromSettings(tab));
    dispatch(changeTab(tabS));
  };
  const handleAbout = () => {
    if (!selDistrictId) {
      toast.error("Select District");
      return;
    }
    handleOpen();
  };
  return (
    <div className="flex flex-col items-end justify-end mt-2">
      <div className="flex m-2">
        <img
          onClick={() => handleAbout()}
          className="px-2 w-11 cursor-pointer"
          alt="About"
          src={about}
        />
        <div 
          onClick={() => handleClick("ContactInfo")} 
          title="Contact Us"
          className="px-2 cursor-pointer flex items-center"
        >
          <PhoneIcon />
        </div>
        <div 
          onClick={() => handleClick("Feedback")} 
          title="Feedback"
          className="px-2 cursor-pointer flex items-center"
        >
          <FeedbackIcon />
        </div>
        <div onClick={() => handleClick("Settings")}>
          <img
            className="px-2 w-11 cursor-pointer"
            alt="Settings"
            src={settings}
          />
        </div>
      </div>
      <div
        onClick={() => setOpenAbout(true)}
        className="cursor-pointer underline flex mx-2 mr-5"
      >
        <p>
          {dis?.name?.text || dis?.name}, {pro?.name?.text || pro?.name}
        </p>
      </div>
      <ModalSettings open={openAbout} handleClose={handleClose} />
    </div>
  );
}

export default Options;
